import React from 'react';
import { useDispatch } from 'react-redux';
import { TInteractiveVote } from '../../../../store/interactive/types';
import { TRoom } from '../../../../store/sockets/types';
import { CheckDoneVote, SendVote } from '../../../../store/interactive/actions';
import { Success } from '../../../../test/screens/Sucess';
import { Polls } from './Polls';

interface VoteProps {
  vote: TInteractiveVote;
  room: TRoom;
  disabled: boolean;
  doneVote: { done: 0 | 1 } | null;
}

export const Vote: React.FC<VoteProps> = ({ vote, room, disabled, doneVote }) => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (room && vote.isFinish === 2) {
      dispatch(
        CheckDoneVote.request({
          data: {
            voteId: vote.id,
            event_id: room.event_id,
            roomId: room.absnum,
          },
        })
      );
    }
  }, [dispatch, vote, room]);

  const sendValue = (value: number) => {
    const isDis = disabled || value === 0;
    if (!isDis) {
      dispatch(
        SendVote.request({
          data: {
            answerId: value,
            voteId: vote.id,
            event_id: room.event_id,
            roomId: room.absnum,
          },
        })
      );
    }
  };

  if (vote.isFinish === 3 || vote.isFinish === 1) {
    return (
      <div style={{ color: 'green', margin: '20px', textAlign: 'center' }}>
        {<span>{vote.isFinish === 1 ? 'Голосування не розпочато' : 'Голосування завершено'}</span>}
      </div>
    );
  }

  if (doneVote === null) {
    return null;
  }

  if (doneVote?.done === 1) {
    return (
      <Success>
        <>
          <h2>Дякуємо! За Ваш голос</h2>
        </>
      </Success>
    );
  }
  return <Polls type="pass" vote={vote} disabled={disabled} sendValue={sendValue} />;
};
